import { Observable, of } from 'rxjs';
import { ComponentDataSourceService } from '../../component-data-source.service';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { map, catchError, tap, shareReplay } from 'rxjs/operators';
import { LoadDataParams } from '../../../../interfaces/DataSource/DataSourceParams.interface';
import { EventUserDTO } from '../../../../dto/event/EventUserDTO';
import { EventUser } from '../../../../models/event/EventUser.model';
import { environment } from '../../../../environment/environment';

export function event_users_not_assigned(
  componentDataSourceService: ComponentDataSourceService,
  http: HttpClient,
  router: Router
) {
    return {
      name: 'EventUsersNotAssigned',
      description: 'Liste af brugere som ikke er tilmeldt et specifikt event',
      execute: (params?: LoadDataParams) => {
        
        const pathSegments = router.url.split('/');
        const eventId = pathSegments.find(segment => 
          /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(segment)
        );
        
        
        // If no eventId, return empty result
        if (!eventId) {
          console.error('No eventId found in URL');
          return of({ items: [], totalCount: 0 });
        }
        
        // Make direct API call since the event API has a different response format
        let apiParams: any = {};
        if (params?.queryParams) {
          // Copy parameters but handle pagination properly
          apiParams = { ...params.queryParams };
          // Convert page to 0-based index for the API if needed
          if (apiParams.page && apiParams.page > 0) {
            apiParams.page = apiParams.page - 1;
          }
        }

        // Pass search term to API (supports both parameter names used by backend)
        const searchTerm = params?.searchQuery || apiParams.searchQuery || apiParams.search;
        if (searchTerm) {
          apiParams.search = searchTerm;
          apiParams.searchQuery = searchTerm;
        }
        
        // Set default pageSize to 25 if not provided
        if (!apiParams.pageSize && !apiParams.page_size) {
          apiParams.pageSize = 25;
        }
        
        
        return http.get<any>(`${environment.apiUrl}/events/${eventId}/non-participants`, 
          { params: apiParams }
        ).pipe(
          tap(result => {
          }),
          catchError(error => {
            console.error('Error fetching non-assigned users:', error);
            return of({ items: [], totalCount: 0 });
          }),
          map(result => {
            
            let users: any[] = [];
            let totalCount = 0;
            
            // Handle array response (direct users array)
            if (Array.isArray(result)) {
              
              users = result.map((userDto: any) => {
                // Ensure the DTO has the proper structure for EventUser.fromDTO
                const eventUserDto = {
                  uuid: userDto.uuid || userDto.id,
                  first_name: userDto.first_name || userDto.firstName || '',
                  last_name: userDto.last_name || userDto.lastName || '',
                  user: userDto.user,
                  roles: userDto.roles,
                  organizations_id: userDto.organizations_id,
                  educational_paths: userDto.educational_paths || userDto.educationalPaths || [],
                  location: userDto.location,
                  location_name: userDto.location_name || userDto.locationName || userDto.primaryLocation,
                  locations: userDto.locations || [],
                  status: userDto.status
                };
                
                const eventUser = EventUser.fromDTO(eventUserDto);
                
                // Debug log to verify the properties
                
                // Add educationalPathsText as a regular property to ensure the table can access it
                const userWithText = {
                  ...eventUser,
                  educationalPathsText: eventUser.educationalPathsText
                };
                
                
                return userWithText;
              });
              
              totalCount = users.length;
            }
            // Handle object response with items property
            else if (result && result.items && Array.isArray(result.items)) {
              
              users = result.items.map((userDto: any) => {
                // Ensure the DTO has the proper structure for EventUser.fromDTO
                const eventUserDto = {
                  uuid: userDto.uuid || userDto.id,
                  first_name: userDto.first_name || userDto.firstName || '',
                  last_name: userDto.last_name || userDto.lastName || '',
                  user: userDto.user,
                  roles: userDto.roles,
                  organizations_id: userDto.organizations_id,
                  educational_paths: userDto.educational_paths || userDto.educationalPaths || [],
                  location: userDto.location,
                  location_name: userDto.location_name || userDto.locationName || userDto.primaryLocation,
                  locations: userDto.locations || [],
                  status: userDto.status
                };
                
                const eventUser = EventUser.fromDTO(eventUserDto);
                
                // Debug log to verify the properties
                
                // Add educationalPathsText as a regular property to ensure the table can access it
                const userWithText = {
                  ...eventUser,
                  educationalPathsText: eventUser.educationalPathsText
                };
                
                
                return userWithText;
              });
              
              totalCount = result.totalCount || result.total || users.length;
            } else {
              console.warn('[event_users_not_assigned] No users found or unexpected response format');
            }
            
            const finalResult = {
              items: users,
              totalCount: totalCount,
              pageSize: params?.queryParams?.['pageSize'] || 25,
              pageIndex: params?.queryParams?.['pageIndex'] || 0,
              filters: params?.filters || []
            };
            
            return finalResult;
          })
        );
      },
      settings: {
        columns: [
          { 
            key: 'name', 
            header: 'Navn', 
            type: 'text' 
          },
          { 
            key: 'primaryLocation', 
            header: 'Lokation', 
            type: 'text' 
          },
          { 
            key: 'educationalPathsText', 
            header: 'Uddannelser', 
            type: 'text'
          }
        ],
        pageable: true,
        pageSize: 25,
        pageSizeOptions: [10, 25, 50, 100],
        sortable: true,
        rowHover: true,
        searchable: true,
        selectable: true,
        multiSelect: true,
        defaultSortColumn: 'name',
        defaultSortDirection: 'asc',
        // Enable persistent selections with uuid as the key field
        persistSelections: true,
        selectionKeyField: 'uuid'
      },
      // Debug: log settings when data source is created
      getSettings: function() {
        return this.settings;
      }
    }
} 